import { getPartnerDetails } from '../utils/helper'
// import { getUserSecret } from './secrets'

export const getConfigDetails = () => {

  //Get the partner
  // const user = window.location.toString().split('/')[3]

  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') {
  // switch ('preprod') {
  switch ('live') {
    case 'demo': //staging2
      return {
        baseURL: 'https://demo-api.parkengage.com/',
        adminUrl: 'https://demo-admin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com',
        // portalURL: 'http://localhost:3000/navigating',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '9f3Blizhmt8qhkw62Y16qTJXa',
        publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'KTlRNfQyLFXRIALiJP6IL9pFo',
        publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
      }
    case 'staging': //staging
      return {
        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.breezeparking.com',
        transientURL: 'https://staging-pci.breezeparking.com',
        portalURL: 'https://staging-customerportal.breezeparking.com',
        FACILITY_ID: getPartnerDetails()?.facilities?.[0]?.id ? getPartnerDetails()?.facilities?.[0]?.id : null, // Uncommented due to Intrapark Business Events tab not showing results
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'KTlRNfQyLFXRIALiJP6IL9pFo',
        publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
      }
    case 'preprod': //staging
      return {
        baseURL: 'https://preprodnew-api.parkengage.com/',
        adminUrl: 'https://preprodnew-admin.parkengage.com',
        checkInUrl: 'https://preprodnew-checkin.parkengage.com',
        transientURL: 'https://preprodnew-transient.parkengage.com',
        portalURL: 'https://preprodnew-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'V8O5ISYRk19Ta77MDasNKgjeZ',
        gatewayDCIframe: 'https://token-cert.dcap.com/v1/client/hosted',
        gatewayHLIframe: 'https://api2.heartlandportico.com/SecureSubmit.v1/token/2.4.1/securesubmit.js',
        chiperKey: 'ij9/kXBIEwuXX2OxjIcLLPMp0q3mVLIMvCk9NWUrm2k=',
        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
        payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
        applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
        payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
        googlePayHLScript: '',
        payButtonHLScript: '',
        recaptchaSiteKey: '6LexXFwtAAAAAO-1nrIyKRYhh_MGrrEOkVAIXyi_',
        publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
      }
    case 'live': //live'
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://adminportal.breezeparking.com',
        checkInUrl: 'https://checkin.breezeparking.com',
        transientURL: 'https://pci.breezeparking.com',
        portalURL: 'https://customerportal.breezeparking.com',
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'V8O5ISYRk19Ta77MDasNKgjeZ',
        chiperKey: 'Xx8HxBc7Z1KO/iJQ/UHAFpPUtNw+ND+W9iIBQIyL05k=',
        recaptchaSiteKey: '6LcIeVwtAAAAALTZAaDbeRg4_wXI4X1sh-gnCXAf',
        publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
      }
  }
}
